import { IClient } from "../Client/Client.model";
import { IContract } from "../Contracts/Contracts.model";
import { JobFrequencyEnum } from "../Contracts/CreateJobAndSchedule/CreateJobAndSchedule.model";

export enum CustomerCategoryEnum {
  INDIVIDUAL = "INDIVIDUAL",
  CORPORATE = "CORPORATE",
}
export enum RecurrenceEnum {
  Y = "Y",
  N = "N",
  NA = "NA",
}

export enum PetsEnum {
  Y = "Y",
  N = "N",
  NA = "NA",
}

export enum LeadStatusEnum {
  Pending = "PENDING",
  Approved = "APPROVED",
  Denied = "DENIED",
  Inprogress = "INPROGRESS",
}

export type TLeadForm = {
  contractTypeId: number;
  projectTypeId?: number;
  customerCategory: CustomerCategoryEnum;
  dateOfApproval: Date;
  name?: string;
  surname?: string;
  companyName?: string;
  contactName?: string;
  billingContact: string;
  billingAddress?: string;
  billingStreet?: string;
  address: string;
  billingZIP: string;
  ZIP: string;
  title: string;
  fax: string;
  website: string;
  billingCity: string;
  city: string;
  billingState: string;
  state: string;
  country: string;
  email: string;
  phone: string;
  street?: string;
  mobile: string;
  estimatedSquareFeet: string;
  depositAmount: number;
  estimatedSQFT: number;
  typeOfSpace: string;
  typeOfFloorSurfaceIds: number[];
  suppliesIds: number[];
  paperProductIds: number[];
  recurrence: RecurrenceEnum;
  recurEvery: number | null;
  daysOfWeek: number[];
  dayOfMonth: number;
  monthOfYear: number;
  frequency: JobFrequencyEnum;
  pets: PetsEnum;
  scopeOfWorkIds: string[];
  estimatedStartDate: Date;
  specialInstruction: string;
  laborGoalHours: number;
  laborGoalBudget: number;
  status: LeadStatusEnum;
  createdDate?: Date;
};

export type TLeadFormData = TLeadForm;

export type TLead = {};

export interface ILeadDetails {
  address: string;
  city: string;
  ZIP: string;
  laborGoalHours: number;
  clientId: string;
  pdfPath: string;
  id: string;
  client: IClient;
  paperProducts: any[];
  supplies: any[];
  sowFrequencies: any[];
  scopeOfWorks: any[];
  customerCategory: CustomerCategoryEnum;
  contactName: string;
  companyName: string;
  name: string;
  surname: string | null;
  phone: string;
  email: string;
  contractTypeId?: number;
  projectTypeId?: number;
  projectType: {
    name: string;
  }
  contractType?: {
    name: string;
  }
  contract?: IContract
}
